module.exports = __webpack_public_path__ + "assets/img/group-logo-82c9574b.png";